// Utilities
import { builderFetch } from '@builder/core/utilities';
import { html } from 'lit';
const { confirm, isEmpty } = _uo.utility;

/**
 * Changes the post status of an item from the recipe
 *
 * @param {String} itemType The item type
 * @param {Number} itemId The item ID
 * @param {Boolean} wantsToSwitchOn Whether the customer wants to switch the item on or off
 * @return {Promise} The apiFetch promise
 */
const setStatusItem = async ( itemType, itemId, wantsToSwitchOn ) => {
	// Event name
	const eventName = 'uap/builder/core/item/set-status-item';

	// Get the item
	const item = UncannyAutomator._core.recipe.item.getItem( itemType, itemId );

	// If the item is not define, stop here
	if ( isEmpty( item ) ) {
		throw new Error( `setStatusItem: The item ${ itemType } ${ itemId } doesn't exist` );
	}

	// Check if the user wants to perform an action that was already performed?
	if ( item.is_item_on === wantsToSwitchOn ) {
		return true;
	}

	// @todo change_post_status: item validation

	if (
		// Check if the customer wants to disable the item
		! wantsToSwitchOn &&
		// Check if the recipe is live
		UncannyAutomator._recipe.is_recipe_on
	) {
		await confirm( {
			content: html`
				<uo-alert type="warning">
					${ _uo.utility.escHTML( wp.i18n.__( 'Setting items to draft in a live recipe can lead to unexpected behaviors.', 'uncanny-automator' ) ) }
				</uo-alert>
			`
		} );
	}

	// Save the recipe title
	return builderFetch( {
		eventName: eventName,
		endpoint: 'change_post_status',
		method: 'POST',
		data: {
			// eslint-disable-next-line camelcase
			post_ID: itemId,
			// eslint-disable-next-line camelcase
			post_status: wantsToSwitchOn ? 'publish' : 'draft',
			// @todo change_post_status: sentence_human_readable_html
			// eslint-disable-next-line camelcase
			sentence_human_readable_html: ''
		},
		snackbar: {
			loading: wantsToSwitchOn
				? _uo.utility.escHTML( wp.i18n.__( 'Switching item on', 'uncanny-automator' ) )
				: _uo.utility.escHTML( wp.i18n.__( 'Switching item off', 'uncanny-automator' ) ),
			success: wantsToSwitchOn
				? _uo.utility.escHTML( wp.i18n.__( 'Item switched on successfully', 'uncanny-automator' ) )
				: _uo.utility.escHTML( wp.i18n.__( 'Item switched off successfully', 'uncanny-automator' ) ),
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( eventName, {
				detail: {
					postID: itemId,
					postStatus: wantsToSwitchOn ? 'publish' : 'draft'
				}
			} ) );
		}

		return response;
	} );
}

export default setStatusItem;
